import React from 'react';
import { osName } from 'react-device-detect';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

class StudyAppPopUp extends React.Component {
  handleClick = () => {
    if (osName === 'iOS') {
      window.location.href =
        'https://apps.apple.com/us/app/bluejacketeer/id978794087';
    }

    if (osName === 'Android') {
      window.location.href =
        'https://play.google.com/store/apps/details?id=com.bluejacketeer.mobile&hl=en_US';
    }

    this.props.closeFunction();
  };

  handleClose = () => {
    this.props.closeFunction();
  };

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.isOpen}
          toggle={this.handleClose}
          className="suscription-expired subscription-expired-free modal-dialog-centered"
        >
          <ModalHeader tag="div" className="danger">
            <i
              className="icon-close top-0 right-0 m-3 position-absolute"
              color="white"
              onClick={this.handleClose}
            />
            <i className="icon-document_download7 big-icon" />
            <h4>Get the Free Companion App!</h4>
          </ModalHeader>
          <ModalBody>
            Download the Free Companion App to get a better user experience
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              size="xs"
              block
              onClick={this.handleClick}
              className="d-flex align-items-center justify-content-center"
            >
              <span>GET APP</span>
              <i className="icon-open" />
            </Button>{' '}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default StudyAppPopUp;
